import React, { useState, useEffect } from 'react';
import { useParams,useHistory } from "react-router-dom";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useStyles,drawerWidth } from "../../layout/styles";
import CrudForm from "../../crud/CrudForm"
import toast from 'toasted-notes'
import 'toasted-notes/src/styles.css';
import {diameterService as service} from "../../../services"

const initElement = {
     name:"",
     sizeMM: null,
     sizeInches: null,
     sizeMMND: null,
     sizeInchesND: null,
     sizeMMRD: null,
     sizeInchesRD: null,

  };


export default function FormDiameter() {
  const classes = useStyles();
  const [objectform, setObjectform] = React.useState({...initElement});


  const estructureform =  [
       {
         type:"input",
         name: "name",
         label: "Nombre",
         col: 6
        },
        {
           type:"input",
           name: "sizeMM",
           label: "Tam. MM",
           col: 6,
           inputtype:"number",
           step:0.01
         },
          {
           type:"input",
           name: "sizeInches",
           label: "Tam. Pulgadas.",
           col: 6,
           inputtype:"number",
           step:0.01
         },
        {
         type:"input",
         name: "sizeInchesND",
         label: "Tam. Pulgadas ND",
         col: 6,
         inputtype:"number",
         step:0.01
        },
        {
         type:"input",
         name: "sizeInchesND",
         label: "Tam. Pulgadas ND",
         col: 6,
         inputtype:"number",
         step:0.01
        },
         {
          type:"input",
          name: "sizeMMRD",
          label: "Tam. mm. RD",
          col: 6,
          inputtype:"number",
          step:0.01
         },
         {
          type:"input",
          name: "sizeInchesRD",
          label: "Tam. Pulgadas RD",
          col: 6,
          inputtype:"number",
          step:0.01
         }

  ];



  const isValid = function(object){
      if(!object['name']){
        toast.notify("Debe indicar el nombre", {position:'top', duration: 10000})
        return false;
      }
      if(!object['sizeMM']){
        toast.notify("Debe indicar el tamaño en mm", {position:'top', duration: 10000})
        return false;
      }
      if(!object['sizeInches']){
        toast.notify("Debe indicar el tamaño en pulgadas", {position:'top', duration: 10000})
        return false;
      }

      return true;
  }

  const recoveryElement = function(objectedit,element){
    objectedit['name']=element.name?element.name:"";
    objectedit['sizeMM']=element.sizeMM?element.sizeMM:"";
    objectedit['sizeInches']=element.sizeInches?element.sizeInches:"";
    objectedit['sizeInchesND']=element.sizeInchesND?element.sizeInchesND:"";
    objectedit['sizeMMND']=element.sizeMMND?element.sizeMMND:"";
    objectedit['sizeMMRD']=element.sizeMMRD?element.sizeMMRD:"";
    objectedit['sizeInchesRD']=element.sizeInchesRD?element.sizeInchesRD:"";
    return objectedit;
  }

  return (
    <CrudForm
        objectform = {objectform}
        estructureform = {estructureform}
        titleEdit = {'Editar Diametro'}
        titleNew = {'Nuevo Diametro'}
        urledit={"/lens/frontdiameter/"}
        urlCancel={"/lens/frontdiameter"}
        service = {service}
        recoveryElement = {recoveryElement}
        valid = {isValid}
      />
  );
}
